import React from "react";
import { motion } from "framer-motion";
import { projekte } from "../helper/data";

const Anschubfoerderung = () => {
  const anschubfoerderungProject = projekte.find(
    (project) => project.titel === "Anschubförderung"
  );

  if (!anschubfoerderungProject) {
    return <p>Projekt nicht gefunden.</p>;
  }

  return (
    <div className="container my-4 text-center">
      <motion.div
        className="announcement bg-light p-3 p-md-5 rounded shadow text-start fs-5"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <img
          src={anschubfoerderungProject.images[0]}
          alt="Anschubsförderung"
          className="img-fluid rounded mb-3"
        />
        <h3 className="fw-semibold text-success mt-3">
          {anschubfoerderungProject.desc.toUpperCase()}
        </h3>
        <div className="mb-3">
          <p className="text-start">{anschubfoerderungProject.desc2}</p>
        </div>
        <div>
          <div>
            <strong>Art der Förderung:</strong> {anschubfoerderungProject.titel}
          </div>

          <div>
            <strong>Projektzeitraum:</strong> 01.07.2025 – 31.12.2025
          </div>

          <div>
            <strong>Durchführungsort:</strong> Neuss im Rhein-Kreis
          </div>

          <div>
            <strong>Zielgruppen:</strong> Kinder und Jugendliche (bis 18 J.),
            Junge Erwachsene (19-27 J.) und Menschen mit Migrationshintergrund.
          </div>
        </div>

        <div className="mt-3">
          <p>{anschubfoerderungProject.desc3}</p>
          <p>{anschubfoerderungProject.desc4}</p>
          <p>{anschubfoerderungProject.desc5}</p>
          <p>{anschubfoerderungProject.desc6}</p>
          <p>{anschubfoerderungProject.desc7}</p>
        </div>
        <div className="mt-5">
          <p className="justify-text text-success fw-semibold">
            {anschubfoerderungProject.desc8}
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default Anschubfoerderung;
